import React, { useState,useEffect } from 'react';
import { FaUser, FaCalendarAlt, FaGlobeAmericas, FaStethoscope, FaChartLine, FaBullseye, FaCalendarCheck } from 'react-icons/fa';

const MetabolismPatientForm = ({
  id, setId,
  patientname, setName,
  age, setAge,
  culturalBackground, setCulturalBackground,
  durationOfDiabetes, setDurationOfDiabetes,
  reasonForConsultation, setReasonForConsultation,
  historicalGlycemic, setHistoricalGlycemic,
  fpg, setFpg,
  ppg, setPpg,
  hba1c, setHba1c,
  targetGoal, setTargetGoal,
  dateOfVisit, setDateOfVisit
}) => {
  const [errors, setErrors] = useState({});
  // Validate Input on Submit
  const validateForm = () => {
    let validationErrors = {};

    if (!id.trim() || !/^[a-zA-Z0-9]+$/.test(id)) validationErrors.id = "Patient ID is required and must be alphanumeric.";
    if (!patientname.trim()) validationErrors.patientname = "Patient Name is required.";
    if (!age.trim() || isNaN(age) || parseInt(age) < 0) validationErrors.age = "Age is required and must be a non-negative number.";
    if (!culturalBackground) validationErrors.culturalBackground = "Cultural Background is required.";
    if (!durationOfDiabetes.trim() || isNaN(durationOfDiabetes) || parseInt(durationOfDiabetes) < 0) validationErrors.durationOfDiabetes = "Duration of Diabetes is required and must be a non-negative number.";
    if (!reasonForConsultation) validationErrors.reasonForConsultation = "Reason for Consultation is required.";
    if (!historicalGlycemic) validationErrors.historicalGlycemic = "Historical Glycemic Control is required.";
    if (!fpg.trim() || isNaN(fpg) || parseInt(fpg) < 0) validationErrors.fpg = "FPG is required and must be a non-negative number.";
    if (!ppg.trim() || isNaN(ppg) || parseInt(ppg) < 0) validationErrors.ppg = "PPG is required and must be a non-negative number.";
    if (!hba1c.trim() || isNaN(hba1c) || parseInt(hba1c) < 0) validationErrors.hba1c = "HbA1c is required and must be a non-negative number.";
    if (!targetGoal.trim() || isNaN(targetGoal) || parseInt(targetGoal) < 0) validationErrors.targetGoal = "Target Goal is required and must be a non-negative number.";
    if (!dateOfVisit) validationErrors.dateOfVisit = "Date of Visit is required.";

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      alert("Form submitted successfully!");
    }
  };
  return (
    <div className="max-w-7xl mx-auto rounded-lg overflow-hidden">
      {/* <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-6">
        <h2 className="text-3xl font-bold text-white">Patient Information Form</h2>
      </div> */}
      <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">

          <FormField icon={<FaUser />} label="Patient ID" type="text" id="patientid" value={id}
              onChange={(e) => e.preventDefault()} placeholder="Enter Patient ID" 
              disabled
              readOnly  error={errors.id}/>
          <FormField icon={<FaUser />} label="Patient Name" type="text" id="patientname" value={patientname} onChange={(e) => setName(e.target.value)} placeholder="Enter Patient Name" error={errors.patientname}/>
          <FormField icon={<FaCalendarAlt />} label="Patient Age" type="text" id="age" value={age} onChange={(e) => setAge(e.target.value)} placeholder="Enter Age" 
          error={errors.age}/>
          <FormField icon={<FaGlobeAmericas />} label="Cultural Background" type="select" id="cultural-background" value={culturalBackground} onChange={(e) => setCulturalBackground(e.target.value)}error={errors.culturalBackground}>
            <option value="">Select Cultural Background</option>
            <option value="Vegetarian">Vegetarian</option>
            <option value="Vegan">Non vegetarian</option>
            <option value="Non-vegetarian">Vegan</option>
            <option value="Eggetarian">Eggetarian</option>
          </FormField>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">

          <FormField icon={<FaStethoscope />} label="Duration of Diabetes" type="text" id="duration-of-diabetes" value={durationOfDiabetes} onChange={(e) => setDurationOfDiabetes(e.target.value)} placeholder="Enter Duration of Diabetes" />
          <FormField icon={<FaStethoscope />} label="Reason For Consultation" type="select" id="disposition" value={reasonForConsultation} onChange={(e) => setReasonForConsultation(e.target.value)} error= {errors.reasonForConsultation}>
            <option value="">Select Reason For Consultation</option>
            <option value="Diagnosis-Confirmation">Diagnosis Confirmation</option>
            <option value="Blood-Glucos-Management">Blood Glucose Management</option>
            <option value="Self-Management">Self Management</option>
            <option value="Complication-Screening-and-Management">Complication Screening and Management</option>
            <option value="Gestational-Diabetes">Gestational Diabetes</option>
            <option value="Medication-Adjustments">Medication Adjustments</option>
          </FormField>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">

          <FormField icon={<FaChartLine />} label="Historical Glycemic Control" type="select" id="historical-glycemic" value={historicalGlycemic} onChange={(e) => setHistoricalGlycemic(e.target.value)} error={errors.historicalGlycemic}>
            <option value="">Select Historical Glycemic</option>
            <option value="Fair">Fair</option>
            <option value="Good">Good</option>
            <option value="Poor">Poor</option>
            <option value="Very Poor">Very Poor</option>
          </FormField>
          <div className="flex space-x-4">
            <FormField icon={<FaChartLine />} label="FPG" type="text" id="fpg" value={fpg} onChange={(e) => setFpg(e.target.value)} placeholder="FPG" error={errors.fpg} />
            <FormField icon={<FaChartLine />} label="PPG" type="text" id="ppg" value={ppg} onChange={(e) => setPpg(e.target.value)} placeholder="PPG" error={errors.ppg} />
            <FormField icon={<FaChartLine />} label="HbA1c" type="text" id="hba1c" value={hba1c} onChange={(e) => setHba1c(e.target.value)} placeholder="HbA1c" error={errors.hba1c}/>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">

          <FormField icon={<FaBullseye />} label="Target or Goal" type="select" id="target-goal" value={targetGoal} onChange={(e) => setTargetGoal(e.target.value)} error={errors.targetGoal}>
            <option value="">Select Target or Goal</option>
            <option value="6">6</option>
            <option value="6.5">6.5</option>
            <option value="7">7</option>
            <option value="7.5">7.5</option>
          </FormField>
          <FormField icon={<FaCalendarCheck />} label="Date of Visit" type="date" id="dateofvisit" value={dateOfVisit} onChange={(e) => setDateOfVisit(e.target.value)} error={errors.dateOfVisit}/>
        </div>


      </div>
    </div>
  );
};

const FormField = ({ icon, label, type, id, value, onChange, placeholder, children }) => {
  return (
    <div>
      <label htmlFor={id} className="flex items-center text-gray-700 font-semibold mb-2">
        <span className="text-indigo-600 mr-2">{icon}</span>
        {label}
      </label>
      {type === 'select' ? (
        <select
          id={id}
className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:border-transparent transition duration-200 ease-in-out sm:text-sm"          value={value} required
          onChange={onChange}
        >
          {children}
        </select>
      ) : (
        <input
          type={type}
          id={id}
className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:border-transparent transition duration-200 ease-in-out sm:text-sm"          value={value} required
          onChange={onChange}
          placeholder={placeholder}
        />
      )}
    </div>
  );
};

export default MetabolismPatientForm;